import {
  SET_DATE_RANGE,
  SET_DATE_PICKER_VISIBILITY,
  OPEN_DATE_PICKER
} from "../actions/datepicker";
import moment from "moment";

const initialState = {
  range: {
    start: moment()
      .subtract(1, "day")
      .startOf("day")
      .toDate(),
    end: moment()
      .startOf("day")
      .toDate()
  },
  visible: false
};

function datepicker(state = initialState, action) {
  const { range, visible } = action;
  switch (action.type) {
    case SET_DATE_RANGE:
      return Object.assign({}, state, { range });

    case SET_DATE_PICKER_VISIBILITY:
      return Object.assign({}, state, { visible });

    case OPEN_DATE_PICKER:
      return Object.assign({}, state, { range, visible: true });

    default:
      return state;
  }
}

export default datepicker;



// WEBPACK FOOTER //
// ./src/reducers/datepicker.js